import { ClassifiedMarkers, GradientDots } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { EVENT_MAP_LEGEND_OBV_LABELS } from '@/consts/visualisations';

export const EventMapObvLegend = () => {
  const { t } = useTranslation('visualisation');

  return (
    <>
      <GradientDots
        labelValues={EVENT_MAP_LEGEND_OBV_LABELS}
        title={t('markerColouring.obv')}
        gradientName="divergent"
      />
      <ClassifiedMarkers title={t('obvColouring.noObv')} markers={[{ label: t('obvColouring.nonValuedEvent') }]} />
    </>
  );
};
